import { Condition, type Customer } from 'types';

export const useCustomerNameWithLabels = (customer?: Partial<Customer> | null): string => {
  if (!customer) {
    return '';
  }

  const extraLabels = [
    customer.is_parent && 'Parent Account',
    customer.billto_ID !== '' && 'Child Account',
    customer.ow30dba && 'OW 30 Day Business Customer',
    customer.is_geek_cover && 'GeekCover Customer',
    customer.prepaid && 'Prepaid Customer',
    customer.invoiced && 'Invoice',
    customer.overdue === Condition.Yes && 'Account Overdue',
    customer.bad_debt === Condition.Yes && 'Bad debt',
    customer.blacklist === Condition.Yes && 'Blacklisted',
  ].filter((l) => l !== false && typeof l !== 'undefined');

  const name = extraLabels.reduce((name, label) => `${name} | ${label}`, customer.name?.full_name || '');

  return name;
};
